import PolicyLayout from './PolicyLayout';
import { CONTACT } from '../constants/contact';
import { SITE_DOMAIN, SITE_NAME } from '../constants/site';

export default function PrivacyPolicy() {
  return (
    <PolicyLayout title="Privacy Policy">
      <p>
        Effective date: June 13, 2026. {SITE_NAME} at <strong>{SITE_DOMAIN}</strong> respects your privacy and is
        committed to protecting personal information shared through this website. This Privacy Policy explains what
        information we collect, how we use it, and what rights you have.
      </p>
      <h2>Scope of This Policy</h2>
      <p>
        This policy applies to data collected through map update inquiry forms, page interactions, support requests,
        and standard analytics tools used for website performance and security monitoring.
      </p>
      <h2>Information We Collect</h2>
      <p>
        We may collect personal information such as your name, email address, phone number, GPS model name, and
        message details when you submit a form or contact us. We may also collect technical information including IP
        address, browser type, device type, operating system, referral source, and visited pages.
      </p>
      <h2>How We Use Information</h2>
      <p>
        We use collected information to respond to map update inquiries, provide guidance for your GPS device,
        improve website content, maintain security, and analyze aggregated usage patterns for service planning.
      </p>
      <h2>Cookies</h2>
      <p>
        Cookies and similar technologies may be used for analytics, session management, and preference storage. You
        can disable cookies in your browser settings; however, some website features may not function properly.
      </p>
      <h2>Data Retention</h2>
      <p>
        We retain personal information only for as long as necessary to respond to your request, maintain inquiry
        records, comply with legal obligations, and prevent abuse.
      </p>
      <h2>Data Security</h2>
      <p>
        We use commercially reasonable safeguards to protect information from improper access, alteration,
        disclosure, or destruction. No internet transmission or storage system is completely secure.
      </p>
      <h2>Third-Party Services</h2>
      <p>
        We may use trusted third-party providers for hosting, analytics, security monitoring, and website
        functionality. These providers may process limited data on our behalf under contractual safeguards.
      </p>
      <h2>Your Rights</h2>
      <p>
        Depending on applicable law, you may request access, correction, deletion, or restriction of your personal
        information. Contact us at <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a> or{' '}
        <a href={`tel:${CONTACT.phoneTel}`}>{CONTACT.phone}</a> for privacy-related requests.
      </p>
      <h2>Policy Updates</h2>
      <p>
        We may update this policy periodically. Revised versions become effective when published on this page with an
        updated effective date.
      </p>
    </PolicyLayout>
  );
}
